// formatta l'orario con lo slash ('/')
export function slashedDate(date, short = false) {
  var array = date.split("-");
  var result = array[2] + "/" + array[1];
  if (!short) result = result + "/" + array[0];

  return result;
}

// formatta la data per il server
export function getDateForServer(date) {
  var myDate = new Date(date);
  var day =
    myDate.getFullYear() +
    "-" +
    ("0" + (myDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + myDate.getDate()).slice(-2);

  return day;
}

const genericSendSvg =
  '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="44" height="43" viewBox="0 0 44 43" > <defs> <clipPath id="clip-path"> <rect id="Rettangolo_9" data-name="Rettangolo 9" width="20" height="20" transform="translate(0.496 0)" fill="#fff" /> </clipPath> </defs> <g id="Raggruppa_40" data-name="Raggruppa 40" transform="translate(-0.496)"> <g id="Rettangolo_10" data-name="Rettangolo 10" transform="translate(0.496)" fill="currentColor" stroke="strokeColor" stroke-width="1" > <rect width="44" height="43" rx="21.5" stroke="none" /> <rect x="0.5" y="0.5" width="43" height="42" rx="21" fill="none" /> </g> <g id="f0103c8ea6235e851f2b3e354c21c705" transform="translate(13 12)" clip-path="url(#clip-path)" > <path id="Tracciato_9" data-name="Tracciato 9" d="M4.038,14.991l6.12-1.224c.546-.109.546-.287,0-.4l-6.12-1.224a1.092,1.092,0,0,1-.792-.792L2.021,5.235c-.109-.547.213-.8.719-.567l18.675,8.619c.337.156.337.409,0,.564L2.74,22.471c-.506.234-.829-.02-.719-.567l1.224-6.12A1.092,1.092,0,0,1,4.038,14.991Z" transform="translate(-1.834 -3.569)" fill="#fff" /> </g> </g> </svg>';

export const renderGenericSendImg = ({ color, stroke }) =>
  "data:image/svg+xml;utf8," +
  encodeURIComponent(
    genericSendSvg
      .replace(/strokeColor/g, stroke || "#835E33")
      .replace(/currentColor/g, color || "currentColor")
  );



// WEBPACK FOOTER //
// ./src/utils.js